@if (showQuestionResponseDistribution) {
    <h3 class="mb-3">{{ surveyQuestion }}</h3>
    <adapt-display-question-response-distribution [survey]="survey$ | async"
                                                  [maxResponseCount]="maxResponseCount"
                                                  (maxResponseCountChange)="maxResponseCountChange.emit($event)"
                                                  [surveyQuestions]="surveyQuestions"
                                                  [questionId]="questionId"></adapt-display-question-response-distribution>
}
@if (!isInitialised) {
    <!-- <div [ngClass]="presentResponseGroups.length === 1 ? 'gauge-placeholder-without-header' : 'gauge-placeholder-with-header'"></div> -->
    <div class="gauge-placeholder"></div>
} @else {
    <div class="d-flex flex-row justify-content-between">
        @for (group of presentResponseGroups; track group) {
            @if ($any(groupStats)[group]; as stats) {
                <div class="d-flex flex-column align-items-center realign-for-print"
                     [ngClass]="presentResponseGroups.length === 1 ? 'w-100' : 'w-50'">
                    @if (stats) {
                        <dx-linear-gauge class="question-stats"
                                         [value]="stats!.average"
                                         [subvalues]="[stats!.min, stats!.max]"
                                         (onInitialized)="onInitialized($event)"
                                         (onDrawn)="isDrawn = true"
                                         (onDisposing)="onDisposing($event)">
                            <dxo-linear-gauge-animation [enabled]="false"></dxo-linear-gauge-animation>
                            @if (!showQuestionResponseDistribution) {
                                <dxo-linear-gauge-size [height]="60"></dxo-linear-gauge-size>
                            }
                            @if (getStatusColorFromPercentage) {
                                <dxo-linear-gauge-value-indicator type="textCloud"
                                                                  [offset]="-5"
                                                                  [color]="getStatusColorFromPercentage!(stats!.average)">
                                    <dxo-linear-gauge-text [customizeText]="customiseScaleText">
                                        <dxo-linear-gauge-font [size]="12"></dxo-linear-gauge-font>
                                    </dxo-linear-gauge-text>
                                </dxo-linear-gauge-value-indicator>
                            }
                            <dxo-linear-gauge-range-container>
                                @for (range of gaugeRanges; track range) {
                                    <dxi-linear-gauge-range [color]="range.color"
                                                            [startValue]="range.startValue"
                                                            [endValue]="range.endValue"></dxi-linear-gauge-range>
                                }
                            </dxo-linear-gauge-range-container>
                            <dxo-linear-gauge-scale [startValue]="0"
                                                    [endValue]="100"
                                                    [customTicks]="tickValues">
                                <dxo-linear-gauge-label [indentFromTick]="5"
                                                        [customizeText]="customiseScaleText">
                                    <dxo-linear-gauge-font [size]="10"></dxo-linear-gauge-font>
                                </dxo-linear-gauge-label>
                            </dxo-linear-gauge-scale>
                            @if (showQuestionResponseDistribution) {
                                <dxo-linear-gauge-title text="Question average"
                                                        verticalAlignment="bottom">
                                    <dxo-linear-gauge-font [size]="16"></dxo-linear-gauge-font>
                                </dxo-linear-gauge-title>
                            }
                            <dxo-linear-gauge-tooltip [enabled]="true"
                                                      [customizeTooltip]="customiseChartTooltip"></dxo-linear-gauge-tooltip>
                        </dx-linear-gauge>
                    }
                    @if (presentResponseGroups.length > 1 && !isXL) {
                        <span class="response-group-header">{{ $any(GroupLabel)[group] }}</span>
                    }
                </div>
            }
        }
    </div>
}
